import React ,{useEffect,useRef} from 'react';
import {connect} from 'react-redux';
const CrusorHover = ({loadingRedux,loadingIntro})=> {
    
    const ref = useRef(null);

    useEffect(() => {
        if(loadingIntro && loadingRedux){
        var cursorinner = ref.current;
        document.addEventListener('mousemove', function(e){
            var x = e.clientX;
            var y = e.clientY;
            cursorinner.style.left = (x) + 'px';
            cursorinner.style.top = (y) + 'px';
        });
        setTimeout(() => {
            const clickableElements = document.querySelectorAll(".clickable");
        clickableElements.forEach(elm => {
        elm.addEventListener("mouseover", function() {
            
            cursorinner.classList.add("hovered");
        });
        elm.addEventListener("mouseleave", function() {
            cursorinner.classList.remove("hovered");
        });  
        });
        }, 500);
        
        const clickableElementssmall = document.querySelectorAll(".clickable_S");
        clickableElementssmall.forEach(elm => {
        elm.addEventListener("mouseover", function() {
            cursorinner.classList.add("hovereds");
        });
        elm.addEventListener("mouseleave", function() {
            cursorinner.classList.remove("hovereds");
        });
        });
        const morphr = document.querySelectorAll(".morphr");
        morphr.forEach(elm => {
        elm.addEventListener("mouseover", function() {
            cursorinner.classList.add("charight");
        });
        elm.addEventListener("mouseleave", function() {
            cursorinner.classList.remove("charight");
        });
        });
        const morphl = document.querySelectorAll(".morphl");
        morphl.forEach(elm => {
        elm.addEventListener("mouseover", function() {
            cursorinner.classList.add("chaleft");
        });
        elm.addEventListener("mouseleave", function() {
            cursorinner.classList.remove("chaleft");
        });
        });
        }
    }, [loadingRedux,loadingIntro])

        document.addEventListener("contextmenu", function(e){
          e.preventDefault();
        }, false);
        document.addEventListener("keydown", function(e) {
        //document.onkeydown = function(e) {
          // "I" key
          if (e.ctrlKey && e.shiftKey && e.keyCode == 73) {
            disabledEvent(e);
          }
          // "J" key
          if (e.ctrlKey && e.shiftKey && e.keyCode == 74) {
            disabledEvent(e);
          }
          // "S" key + macOS
          if (e.keyCode == 83 && (navigator.platform.match("Mac") ? e.metaKey : e.ctrlKey)) {
            disabledEvent(e);
          }
          // "U" key
          if (e.ctrlKey && e.keyCode == 85) {
            disabledEvent(e);
          }
          // "F12" key
          if (e.keyCode == 123) {
            disabledEvent(e);
          }
        }, false);
        function disabledEvent(e){
          if (e.stopPropagation){
            e.stopPropagation();
          } else if (window.event){
            window.event.cancelBubble = true;
          }
          e.preventDefault();
          return false;
        }

        return(
            loadingIntro && loadingRedux?<div className="cursor--outer" ref={ref}></div>:""
        )

}
const mapStateToProps = ({loading}) => {
    return {
        loadingRedux: loading.type,
        loadingIntro : loading.typeintro,
    }
  };
export default connect(mapStateToProps,null)(CrusorHover);